import Breadcrumb from "../../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../../services/ProcessamentoService";

export default {
    name: "ImportarProcessosEmpenho",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Processos de Empenho',
                disabled: false
            },
            {
                text: 'Importar Processos de Empenho',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        isDragOver: false
    }),
    created() {
        this.loadScheduledList();
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('empenhos');
            this.scheduledList = scheduledList.data;
        },
        
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        
        // Novos métodos para drag & drop
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.processFile(file);
            }
        },
        
        handleFileDrop(event) {
            this.isDragOver = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.processFile(files[0]);
            }
        },
        
        processFile(file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel' // .xls
            ];
            
            if (!allowedTypes.includes(file.type)) {
                SnackBarModule('Formato de arquivo não suportado. Use .xlsx ou .xls', 'error');
                return;
            }
            
            this.arquivo = file;
            this.uploadFile();
        },
        
        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'empenhos');

            ProcessamentoService.store(formData)
                .then(response => {
                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
            this.blockInputFile = false;
        },
        
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        
        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },
        
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },
        
        getStatusColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        
        getStatusChipColor(item) {
            if (!item.processado) {
                return 'orange';
            } else if (item.erro) {
                return 'red';
            } else {
                return 'green';
            }
        },
        
        getStatusTextColor(item) {
            if (!item.processado) {
                return 'white';
            } else if (item.erro) {
                return 'white';
            } else {
                return 'white';
            }
        }
    }
};